// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3ozQW","label":"Category_label__1cfUZ","content":"Category_content__1Cly5","header":"Category_header__3e2E4","location":"Category_location__3g2Tv"};